import {
  Checkbox,
  Dialog,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
  Slide,
  Typography,
  Button,
  TextField,
  Box,
} from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  backgroundColor: "#EBEFF3",
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary expandIcon={<ExpandMoreIcon />} {...props} />
))(({ theme }) => ({
  backgroundColor: "#EBEFF3",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    position: "absolute",
    bottom: 0,
    margin: 0,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    width: "100%",
    backgroundColor: "#EBEFF3",
  },
  searchInput: {
    marginBottom: "10px",
    width: "100%",
  },
  selectAllCheckbox: {
    marginBottom: "10px",
  },
  optionLabel: {
    fontSize: "16px",
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
  optionCheckbox: {
    color: theme.palette.primary.main,
  },
  optionInput: {
    marginBottom: "10px",
  },
  button: {
    marginTop: theme.spacing(2),
    textTransform: "capitalize",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  confirmButton: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  cancelButton: {
    color: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
  },
}));

const GenericDialog = ({
  open,
  onClose,
  onConform,
  title,
  options = [],
  value,
  onValueChange,
  ifExams = false,
  checked = [],
}) => {
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = React.useState("");

  const handleCheckboxChange = (value) => {
    const currentChecked = Array.isArray(checked) ? [...checked] : [];

    if (currentChecked.includes(value)) {
      // Remove the value if it's already checked
      const newChecked = currentChecked.filter((item) => item !== value);
      onValueChange(newChecked);
    } else {
      // Add the value if it's not checked
      const newChecked = [...currentChecked, value];
      onValueChange(newChecked);
    }
  };

  const handleRadioChange = (event) => {
    onValueChange(event.target.value);
  };

  // Fixed: Handle select all for a specific group - now works with filtered options
  const handleSelectAllForGroup = (group, filteredGroupOptions) => {
    const currentChecked = Array.isArray(checked) ? [...checked] : [];
    // Use filtered options instead of all group options
    const groupOptionValues = filteredGroupOptions.map(
      (option) => option.value
    );

    // Check current state of the filtered group
    const fullySelected = isGroupFullySelected(group, filteredGroupOptions);

    let newChecked;
    if (fullySelected) {
      // If all filtered options are selected, deselect all in this filtered group
      newChecked = currentChecked.filter(
        (item) => !groupOptionValues.includes(item)
      );
    } else {
      // If none or some filtered options are selected, select all filtered options
      newChecked = [...new Set([...currentChecked, ...groupOptionValues])];
    }

    // Pass the complete new array to parent
    onValueChange(newChecked);
  };

  // Fixed: Check if all filtered options in a group are selected
  const isGroupFullySelected = (group, filteredGroupOptions = null) => {
    const optionsToCheck = filteredGroupOptions || group.options;

    if (
      !Array.isArray(checked) ||
      checked.length === 0 ||
      !Array.isArray(optionsToCheck) ||
      optionsToCheck.length === 0
    ) {
      return false;
    }
    return optionsToCheck.every((option) => checked.includes(option.value));
  };

  const filteredOptions = Array.isArray(options)
    ? options
        .map((group) => {
          const filteredGroupOptions = Array.isArray(group.options)
            ? group.options.filter((option) =>
                option.label.toLowerCase().includes(searchTerm.toLowerCase())
              )
            : [];

          return {
            ...group,
            options: filteredGroupOptions,
          };
        })
        .filter((group) => group.options.length > 0)
    : [];

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
      fullWidth
    >
      <Box padding={1} display="flex" justifyContent="center">
        <Typography
          variant="h6"
          style={{ fontWeight: "bold", color: "#1e90ff" }}
        >
          {title}
        </Typography>
      </Box>
      <Box
        className={classes.dialogContent}
        padding={1}
        width="100%"
        display="flex"
        flexDirection="column"
      >
        {ifExams ? (
          <>
            {filteredOptions.map((group, groupIndex) => {
              // Get the original group for reference
              const originalGroup = options.find(
                (og) => og.group === group.group
              );
              return (
                <Accordion key={groupIndex}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      fontSize="16px"
                      color="primary"
                      style={{ fontWeight: "bold" }}
                    >
                      {group.group} (
                      {
                        group.options.filter((opt) =>
                          checked.includes(opt.value)
                        ).length
                      }
                      /{group.options.length})
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box display="flex" flexDirection="column" width="100%">
                      {groupIndex === 0 && (
                        <TextField
                          className={classes.searchInput}
                          variant="outlined"
                          placeholder="Search options..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          size="small"
                          InputProps={{
                            style: {
                              borderColor: "#1e90ff",
                              borderRadius: "4px",
                            },
                          }}
                        />
                      )}
                      {group.options.length === 0 && (
                        <Typography>
                          {searchTerm
                            ? "No tests match your search."
                            : "No tests available."}
                        </Typography>
                      )}
                      {group.options.length > 0 && (
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={isGroupFullySelected(
                                  originalGroup,
                                  group.options
                                )}
                                onChange={() =>
                                  handleSelectAllForGroup(
                                    originalGroup,
                                    group.options
                                  )
                                }
                                color="primary"
                              />
                            }
                            label={`Select All (${group.options.length})`}
                          />
                        </FormGroup>
                      )}
                      <FormGroup>
                        {group.options.map((option, index) => {
                          return (
                            <Box
                              key={index}
                              display="flex"
                              alignItems="center"
                              justifyContent="space-between"
                              width="100%"
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={
                                      Array.isArray(checked) &&
                                      checked.includes(option.value)
                                    }
                                    onChange={() =>
                                      handleCheckboxChange(option.value)
                                    }
                                    value={option.value}
                                    color="primary"
                                  />
                                }
                                label={
                                  option.label.length > 20
                                    ? option.label.slice(0, 20) + "..."
                                    : option.label
                                }
                              />
                              <Typography variant="body2" color="textSecondary">
                                {option.test_graph_name}
                              </Typography>
                            </Box>
                          );
                        })}
                      </FormGroup>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </>
        ) : (
          <RadioGroup value={value} onChange={handleRadioChange}>
            {options.map((option, index) => (
              <FormControlLabel
                key={index}
                value={option.value}
                control={<Radio color="primary" />}
                label={option.label}
                className={classes.optionLabel}
                classes={{
                  label: classes.optionLabel,
                  root: classes.optionCheckbox,
                }}
              />
            ))}
          </RadioGroup>
        )}
        <Box className={classes.buttonGroup}>
          <Button
            onClick={onClose}
            variant="outlined"
            className={classes.cancelButton}
          >
            Cancel
          </Button>
          <Button
            onClick={onConform}
            variant="contained"
            className={classes.confirmButton}
          >
            Confirm
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default GenericDialog;
